// @flow
import { createUploadLink } from 'apollo-upload-client';

const uploadLink = createUploadLink({
    uri: process.env.RAZZLE_GRAPHQL_SERVER,
    credentials: 'same-origin',
});

export default uploadLink;
